import React from "react";
import * as s from "../index.module.scss";
import { IoHeadset } from "react-icons/io5";
import secondaryFont from "@/utils/secondaryFont";
import links from "../utils/data";
import NavLinks from "./NavLinks";

const NavigationItems = ({ expanded, setExpanded, setToggle, toggle }) => {
  return (
    <div className={s.nav_links_container}>
      <div className={`flex-row-reverse ${s.call_link}`}>
        <a href="tel: (212) 913-9141" className={secondaryFont}>
          <IoHeadset size="20px" /> <span>Call us on</span> (212) 913-9141
        </a>
      </div>
      <nav className={`${s.nav_links} d-lg-block`}>
        <NavLinks
          links={links}
          setExpanded={setExpanded}
          toggle={toggle}
          setToggle={setToggle}
        />
      </nav>
    </div>
  );
};

export default NavigationItems;
